/**
 * ANOVA 事後検定手法の pros/cons（レガシー ANOVAView 相当）
 */

import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const POST_HOC_METHODS = ['tukey', 'bonferroni', 'holm', 'scheffe', 'dunnett'] as const;

type PostHocMethod = (typeof POST_HOC_METHODS)[number];

function isPostHocMethod(value: string): value is PostHocMethod {
  return (POST_HOC_METHODS as readonly string[]).includes(value);
}

interface AnovaPostHocMethodInfoPanelProps {
  postHoc: string;
}

export default function AnovaPostHocMethodInfoPanel({ postHoc }: AnovaPostHocMethodInfoPanelProps) {
  const { t } = useTranslation();
  if (!postHoc || !isPostHocMethod(postHoc)) return null;

  const cap = postHoc.charAt(0).toUpperCase() + postHoc.slice(1);
  const prosKey = `keisuke.anova.method${cap}Pros`;
  const consKey = `keisuke.anova.method${cap}Cons`;
  const useKey = `keisuke.anova.method${cap}Use`;

  return (
    <Accordion flush className="mt-2">
      <Accordion.Item eventKey="posthoc-info">
        <Accordion.Header>{t('keisuke.anova.postHocMethodInfoTitle')}</Accordion.Header>
        <Accordion.Body className="small">
          <p className="mb-1">
            <strong>{t('keisuke.anova.advantages')}:</strong>{' '}
            {t(prosKey)}
          </p>
          <p className="mb-1">
            <strong>{t('keisuke.anova.disadvantages')}:</strong>{' '}
            {t(consKey)}
          </p>
          <p className="mb-0 text-muted">{t(useKey)}</p>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}
